<template>
  <span class="logo" v-if="carrier">
    <img :src="carrier.logo" height="25px" />
  </span>
</template>

<script>
export default {
  name: "CarrierLogo",
  props: {
    item: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    carriers() {
      const carrierItems = structuredClone(this.$store.state.shippingData.carriers) || [];

      return carrierItems;
    },
    carrier() {
      const res = this.getCarrierByName(this.item);
      return res;
    },
  },
  methods: {
    getCarrierByName(_name) {
      if (typeof _name === "object") {
        return _name;
      }
      return this.carriers.find((carrier) => carrier.name === _name);
    },
  },
  created() {
    if (!this.$store.state.shippingData.carriers || this.$store.state.shippingData.carriers.length === 0) {
      this.$store.dispatch("shippingData/getCarriers");
    }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 50px;
  max-height: 25px;
  border-radius: 15px;
  background-color: #e0e0e0;
  overflow: hidden;
  img {
    max-height: 25px;
    border-radius: 15px;
  }
}
</style>
